/*
 * Copyright (C) 2019 - present Marek Kuzora - All Rights Reserved.
 */


import { css, styled } from 'fierry/react.old';


export const Container = styled.div`
  position: relative;
`;


const topConfig = ({ position }) => position && position.top != null && css`
  top: ${position.top}%;
`;

const bottomConfig = ({ position }) => position && position.bottom != null && css`
  bottom: ${position.bottom}%;
`;

const leftConfig = ({ position }) => position && position.left != null && css`
  left: ${position.left}%;
`;

const rightConfig = ({ position }) => position && position.right != null && css`
  right: ${position.right}%;
`;


export const Annotation = styled.div`
  position: absolute;

  ${topConfig}
  ${bottomConfig}

  ${leftConfig}
  ${rightConfig}
`;
